module.exports = __webpack_public_path__ + "img/diners-club.3073e85b.png";